import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Button } from 'planoplan-ui-kit/core/button';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { useTranslations } from '@libs/translations';
import { DownloadButton } from './download-button';
import { Points } from '@styles';

const Eye = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M1.3335 7.99967C1.3335 7.99967 3.75774 3.33301 8.00016 3.33301C12.2426 3.33301 14.6668 7.99967 14.6668 7.99967C14.6668 7.99967 12.2426 12.6663 8.00016 12.6663C3.75774 12.6663 1.3335 7.99967 1.3335 7.99967Z"
      stroke="#292929"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="#292929"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FinalSlide = () => {
  const translations = useTranslations();
  const isTabletPortrait = useMediaQuery(Points.tablet_landscape, { useSSR: true });
  const isDesktopWide = useMediaQuery(Points.laptop_wide, { useSSR: true });
  const isMobileDevice = deviceDetected.isMobile;
  const { locale } = useSelector((state) => state.settings);

  return (
    <View>
      <Button
        theme="neutral_secondary"
        data-gtm="button_click"
        className="watch-button"
        size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'}
        href={`blog/interview/`}>
        <Eye /> {translations.t(`site.home.direct-speech.viewAllStoriesBtn`)}
      </Button>
      {isMobileDevice ? (
        <Button theme="primary" size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'} href={`/${locale}/download`}>
          {translations.t('site.home.firstscreen.mobileBtnDownload')}
        </Button>
      ) : (
        <DownloadButton />
      )}
    </View>
  );
};

const View = styled.div`
  width: 100%;
  height: 100%;
  padding: 22px;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${Colors.main_dark};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: ${Colors.white};

  & .watch-button {
    width: 100%;
    display: flex;
    gap: 8px;
  }

  @media ${Points.tablet_landscape} {
    width: 300px;
    padding: 30px;
  }

  @media ${Points.laptop_wide} {
    width: 400px;
    padding: 50px;
  }
`;
